module.exports = __webpack_public_path__ + "img/o_8.13d0dd75.png";